module.exports = __webpack_public_path__ + "img/seating.e330dd0d.png";